export class Product {
    constructor(id, idc, title, price, imageUrl) {
        this.id = id;
        this.idc = idc;
        this.title = title;
        this.price = price;
        this.imageUrl = imageUrl;
    }
}
